'use client';
import Container from "./Container.js";
export default Container;